import { render, staticRenderFns } from "./ScanIn4.vue?vue&type=template&id=476f98a3&scoped=true&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml"
import script from "./ScanIn4.vue?vue&type=script&lang=js"
export * from "./ScanIn4.vue?vue&type=script&lang=js"
import style0 from "./ScanIn4.vue?vue&type=style&index=0&id=476f98a3&prod&lang=scss&scoped=true"
import style1 from "./ScanIn4.vue?vue&type=style&index=1&id=476f98a3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476f98a3",
  null
  
)

export default component.exports